import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  uploadFileError: {
    id: 'files.upload.error',
    defaultMessage: 'There was an error while uploading your {count, plural, one {file} other {files}}'
  }
})
